module.exports = __webpack_public_path__ + "img/phone-off.34501ede.svg";